export function removeInvisibleElements(
  visibilityConfig: Record<string, boolean> | undefined | null
) {
  try {
    // Handle cases where visibilityConfig is null/undefined or not an object
    if (!visibilityConfig || typeof visibilityConfig !== 'object') {
      return;
    }

    const entries = Object.entries(visibilityConfig);

    // Safely iterate over entries
    entries?.forEach(([key, isVisible]) => {
      try {
        // Skip if key is not a string or isVisible is not a boolean
        if (typeof key !== 'string' || typeof isVisible !== 'boolean') {
          return;
        }

        if (!isVisible) {
          const elements = document.querySelectorAll(
            `[data-element-key="${key}"]`
          );
          elements?.forEach((el) => el?.remove());
        }
      } catch (error) {
        console.error(`Error processing element with key ${key}:`, error);
      }
    });
  } catch (error) {
    console.error('Error in removeInvisibleElements:', error);
  }
}
